'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var useOutsideClick = function useOutsideClick(ref, callback) {
    var handleClick = function handleClick(e) {
        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    };
    (0, _react.useEffect)(function () {
        document.addEventListener('click', handleClick);
        return function () {
            document.removeEventListener('click', handleClick);
        };
    });
};
exports.default = useOutsideClick;
//# sourceMappingURL=useOutsideClick.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/helpers/useOutsideClick.js
// module id = 1877
// module chunks = 0